import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-choice-button",
    styleUrls: ["./choice-button.component.scss"],
    templateUrl: "./choice-button.component.html",
    standalone: false
})
export class FUIChoiceButtonComponent extends FUIButtonComponent {

}
